var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.615234,
    y: 0.117188,
    width: 36,
    height: 36,
    rx: 18,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7839 9.11719H26.5309L20.5309 16.7572L27.6152 27.1172H22.049L17.7116 20.8372L12.7237 27.1172H9.97668L16.4104 18.9572L9.61523 9.11719H15.3261L19.2658 14.8772L23.7839 9.11719ZM22.808 25.2772H24.3261L14.4948 10.8372H12.8321L22.808 25.2772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.883e29140a6757a205c7475c9d991da3.svg";
export { ForwardRef as ReactComponent };